import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconRedExclamation = createIcon({
  viewBox: '0 0 60 60',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 54C43.2548 54 54 43.2548 54 30C54 16.7452 43.2548 6 30 6C16.7452 6 6 16.7452 6 30C6 43.2548 16.7452 54 30 54ZM27.0001 17C27.0001 15.8954 27.8956 15 29.0001 15H31.0001C32.1047 15 33.0001 15.8954 33.0001 17V31C33.0001 32.1046 32.1047 33 31.0001 33H29.0001C27.8956 33 27.0001 32.1046 27.0001 31V17ZM33.0003 40C33.0003 41.6569 31.6571 43 30.0003 43C28.3434 43 27.0003 41.6569 27.0003 40C27.0003 38.3432 28.3434 37 30.0003 37C31.6571 37 33.0003 38.3432 33.0003 40Z"
      fill="#D50000"
    />
  ),
});

export default IconRedExclamation;
